import { useTranslation } from 'react-i18next';
import { FallbackProps } from 'react-error-boundary';

import SadIcon from '../../icons/sad_face_96.svg';

import { Button, Typography } from '@destination/components';

export const GeneralFallback = ({
  resetErrorBoundary
}: FallbackProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full text-center">
      <div className="flex h-8">
        <Typography className="mx-auto mt-auto !leading-4" variant="smallTitle">
          {t('general.application_name')}
        </Typography>
      </div>
      <div className="mb-8 flex justify-center" data-testid="sad-icon">
        <SadIcon />
      </div>
      <div className="flex flex-col justify-center text-center">
        <Typography variant="smallTitle" className="mb-6">
          {t('general.something_went_wrong')}
        </Typography>
        <Typography variant="description">
          {t('general.go_back_and_try_again')}
        </Typography>
        <div className="tw-mt-6 tw-flex tw-justify-center">
          <Button variant="primary" onClick={resetErrorBoundary}>
            <Typography variant="smallText">
              {t('general.try_again')}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};
